import React from "react";
import { Loading } from "../../components";
import { AffiliateSettingInterface, ApiHelper } from "../../helpers";

interface Props {
  affiliateSetting: AffiliateSettingInterface
}

export const Affiliates: React.FC<Props> = props => {

  const [affiliates, setAffiliates] = React.useState<{ name: string, amount: number }[]>(null);

  const init = () => {
    if (props.affiliateSetting) {
      ApiHelper.get("/affiliateSettings/affiliates/" + props.affiliateSetting.code).then(d => setAffiliates(d));
    }
  }

  React.useEffect(init, [props.affiliateSetting]); //eslint-disable-line

  if (!affiliates) return <Loading />
  else if (affiliates.length === 0) return <p>You do not have any affiliates yet.</p>
  else {
    const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
    const rows: React.ReactElement[] = [];
    affiliates.forEach(a => {
      rows.push(<tr>
        <td>{a.name}</td>
        <td>{formatter.format(a.amount)}</td>
        <td>{formatter.format(a.amount * props.affiliateSetting.screenCommission / 100)}</td>
      </tr>);
    });

    return (<>
      <b>{props.affiliateSetting?.code}</b><br />
      <table className="table table-sm table-striped" >
        <thead>
          <tr>
            <th>Name</th>
            <th>Monthly Charges</th>
            <th>Expected Commission</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    </>);
  }
};